import { createAction } from "@reduxjs/toolkit"

export const setCart = createAction<any>("cart/setCart")
